// extracted by mini-css-extract-plugin
export default {"wrapper":"LearningNote_wrapper__+ylg8","panelHeader":"LearningNote_panelHeader__UIJgw","header":"LearningNote_header__9yvXy","actions":"LearningNote_actions__dnpOZ"};